var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Account" }, [
    _vm.step == 1
      ? _c(
          "form",
          {
            staticClass: "account-1",
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.validatePasswords($event)
              }
            }
          },
          [
            _c("div", { staticClass: "grid" }, [
              _c("div", { staticClass: "unit half" }, [
                _c("label", { attrs: { for: "p1" } }, [
                  _vm._v(
                    "\n                    Password\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account.password,
                        expression: "account.password"
                      }
                    ],
                    attrs: {
                      type: "password",
                      minlength: "8",
                      id: "p1",
                      placeholder: "At least 8 chars.",
                      autofocus: "",
                      required: ""
                    },
                    domProps: { value: _vm.account.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.account, "password", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "p2" } }, [
                  _vm._v(
                    "\n                    Repeat Password\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account.confirmPassword,
                        expression: "account.confirmPassword"
                      }
                    ],
                    attrs: {
                      type: "password",
                      minlength: "8",
                      id: "p2",
                      placeholder: "Same password again",
                      required: ""
                    },
                    domProps: { value: _vm.account.confirmPassword },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.account,
                          "confirmPassword",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "unit half" }, [
                _c("label", [
                  _vm._v("\n                    Email\n                    "),
                  _c("input", {
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: _vm.email }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step == "2"
      ? _c(
          "form",
          {
            staticClass: "account-2",
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.done($event)
              }
            }
          },
          [
            _c("div", { staticClass: "grid" }, [
              _c("div", { staticClass: "unit half" }, [
                _c("label", { attrs: { for: "name" } }, [
                  _vm._v(
                    "\n                    Full Name\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account.name,
                        expression: "account.name"
                      }
                    ],
                    attrs: {
                      type: "text",
                      id: "name",
                      placeholder: "John Doe",
                      autofocus: "",
                      required: ""
                    },
                    domProps: { value: _vm.account.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.account, "name", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "unit half" }, [
                _c("label", { attrs: { for: "role" } }, [
                  _vm._v(
                    "\n                    Position\n                    "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.account.role,
                        expression: "account.role"
                      }
                    ],
                    attrs: {
                      type: "text",
                      id: "role",
                      placeholder: "Chief Productivity Officer",
                      required: ""
                    },
                    domProps: { value: _vm.account.role },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.account, "role", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-action" }, [
      _c("button", { staticClass: "continue simple" }, [_vm._v("Continue")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-action" }, [
      _c("button", { staticClass: "continue simple" }, [_vm._v("Continue")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a8b141c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8b141c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/Account.vue
// module id = 479
// module chunks = 0